import {Component, OnInit, signal, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {GoogleMap} from '@angular/google-maps';
import {CodaltComponent} from '../codalt/codalt.component';
import {Project} from '../../classes/project';
import {ProjectService} from '../../services/project.service';
import {Routenames} from '../../routenames';
import {FormControl} from '@angular/forms';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {debounceTime} from 'rxjs/operators';
import {Utils} from '../../utils.class';
import {Title} from '@angular/platform-browser';
import {TtmTicketService} from '../../services/ttm-ticket.service';
import {AuthorisationService} from '../../services/auth/authorisation.service';
import {Features} from '../../services/auth/features';
import {LocalStorage} from '../../utils/storage';
import {Roles} from '../../services/auth/roles';

@Component({
    selector: 'app-projects-map',
    templateUrl: './projects-map.component.html',
    styleUrl: './projects-map.component.scss'
})
export class ProjectsMapComponent extends CodaltComponent implements OnInit {
    options: google.maps.MapOptions = {
        mapId: '55a928ad53a65407',
        center: {lat: 52.5, lng: 6},
        zoom: 8,
        minZoom: 7,
        tilt: 0,
        headingInteractionEnabled: false,
        isFractionalZoomEnabled: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControl: false,
        streetViewControl: false,
        restriction: Utils.RestrictToNl()
    };
    @ViewChild('googleMap') googleMap: GoogleMap;

    projects: Project[];
    fcSearch = new FormControl<string>(null);
    viewState = {
        search: true
    };

    newTicketCount = signal<number>(0);

    constructor(private router: Router,
                private confirmDialogService: ConfirmDialogService,
                private projectService: ProjectService,
                private ticketService: TtmTicketService,
                private title: Title) {
        super();
    }

    ngOnInit() {
        this.title.setTitle('Projecten - TSNed App');

        this.subscriptions.add(this.projectService.list().subscribe(response => {
            this.projects = response.data;
        }));
        this.subscriptions.add(this.fcSearch.valueChanges.pipe(debounceTime(250)).subscribe(searchText => {
            this.subscriptions.add(this.projectService.list(searchText).subscribe(response => {
                this.projects = response.data;
            }));
        }))

        if (AuthorisationService.hasFeature(Features.TtmTicketDetail)) {
            this.subscriptions.add(this.ticketService.getTicketsByStatus('new').subscribe(response => {
                let tickets = response.data;

                tickets = tickets.filter(ticket => {
                    const isNewForCodalt = ticket.department === 'technical' && AuthorisationService.hasRole(Roles.Codalt);
                    const isNewForDrawer = ticket.department === 'drawing' && AuthorisationService.hasRole(Roles.Drawer);

                    if (isNewForCodalt || isNewForDrawer) {
                        return true;
                    }

                    return ticket.assignee_id === LocalStorage.user?.id || ticket.user_id === LocalStorage.user?.id;
                });

                this.newTicketCount.set(tickets.length);
            }));
        }

    }

    logout() {
        this.confirmDialogService.confirm('Uitloggen',
            'Weet je zeker dat je wilt uitloggen?',
            'Uitloggen', 'Annuleren').then(() => {
            this.router.navigate([Routenames.Logout]);
        }, () => {

        });
    }

    toggleSearchBar() {
        this.viewState.search = !this.viewState.search;
        if (this.viewState.search) {
            setTimeout(() => {
                (document.querySelector('#ttmSearchInput') as HTMLInputElement).focus();
            });
        }
    }


    openProject(project: Project) {
        this.router.navigate([Routenames.Projects, project.id]);
    }
}
